import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'lx-offer-label-lite',
  templateUrl: './offer-label.component.html',
  styleUrls: ['./offer-label.component.scss'],
})
export class OfferLabelComponent {
  text = input<string | undefined>();
}
